export const STORAGE_KEYS = {
  token: "jo_token",
};

export const PERMISSIONS = {
  ADD: "add job order",
  UPDATE: "update job order",
  DELETE: "delete job order",
};

/* API status keys → the reference UI's labels, badge/dot classes and colours. */
export const STATUS_META = {
  pending: {
    label: "Pending",
    option: "⌛ Pending Approval",
    chartLabel: "Pending",
    badge: "badge-pending",
    dot: "dot-pending",
    legendClass: "status-item-pending",
    color: "#f59e0b",
  },
  in_progress: {
    label: "In progress",
    option: "⚙️ In Progress / Production",
    chartLabel: "In Production",
    badge: "badge-progress",
    dot: "dot-progress",
    legendClass: "status-item-progress",
    color: "#3b82f6",
  },
  completed: {
    label: "Completed",
    option: "✅ Completed",
    chartLabel: "Completed",
    badge: "badge-completed",
    dot: "dot-completed",
    legendClass: "status-item-completed",
    color: "#10b981",
  },
  on_hold: {
    label: "On hold",
    option: "⏸️ On Hold",
    chartLabel: "On Hold",
    badge: "badge-onhold",
    dot: "dot-onhold",
    legendClass: "status-item-onhold",
    color: "#8b5cf6",
  },
};

export const STATUS_KEYS = ["pending", "in_progress", "completed", "on_hold"];

export const PAYMENT_META = {
  cash: { option: "💵 Cash", doc: "Cash" },
  card: { option: "💳 Card", doc: "Card" },
  transfer: { option: "🏦 Bank Transfer", doc: "Transfer" },
  other: { option: "🔄 Other", doc: "Other" },
};

export const RECIPIENT_META = {
  delivered: { option: "📦 Delivered", doc: "Delivered" },
  collected: { option: "🏬 Collected", doc: "Collected" },
  none: { option: "🚫 None", doc: "None" },
};

/* Calendar & Schedule item types (API: job | meeting | task). */
export const EVENT_TYPES = ["job", "meeting", "task"];

export const EVENT_TYPE_META = {
  job: {
    label: "Work Job",
    chip: "💼 Work / Job",
    chipClass: "chip-job",
    badge: "💼 WORK JOB",
    badgeClass: "badge-job",
    filter: "💼 Jobs",
    plural: "jobs",
  },
  meeting: {
    label: "Client Meeting",
    chip: "🤝 Client Meeting",
    chipClass: "chip-meeting",
    badge: "🤝 CLIENT MEETING",
    badgeClass: "badge-meeting",
    filter: "🤝 Meetings",
    plural: "meetings",
  },
  task: {
    label: "Task",
    chip: "✅ Task",
    chipClass: "chip-task",
    badge: "✅ TASK",
    badgeClass: "badge-task",
    filter: "✅ Tasks",
    plural: "tasks",
  },
};

export const REMINDER_OPTIONS = [
  { value: "none", label: "No Reminder" },
  { value: "today", label: "On Event Day (Morning 09:00 AM)" },
  { value: "1day", label: "1 Day Before" },
  { value: "2days", label: "2 Days Before" },
];

export const SCHEDULE_DELETE_CONFIRM = "Are you sure you want to remove this schedule item?";

export const MONTH_FULL_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const WEEKDAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

/* Chip labels from the reference wizard; unknown services fall back to the plain name. */
export const SERVICE_CHIPS = {
  "Printing & Branding": "🖨️ Printing & Branding",
  Photography: "📷 Photography",
  Videography: "🎥 Videography",
  "Graphic Design": "🎨 Graphic Design",
  Signage: "🪧 Signage",
  "Digital/E-commerce": "💻 Digital / E-commerce",
  "NFC/QR": "📱 NFC / QR",
  Other: "✨ Other",
};

export const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const DELETE_CONFIRM = "Are you sure you want to delete this Job Order? This action cannot be undone.";
